
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/tokens",
      function () {
        return require("private-next-pages/account/tokens.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/tokens"])
      });
    }
  